module.exports = __webpack_public_path__ + "media/images/emoticons/event-5ba1d7461a05533e7ac6e7d37109c1ff.gif";